
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import axios from 'axios';
import { API_BASE_URL } from '../../config';

const CTCBar = () => {
  const [options, setOptions] = useState({
    chart: { id: 'ctc-bar' },
    xaxis: { categories: [] },
    fill: { colors: ['#FD7B5D', '#FF8954', '#FF9847', '#FF9B44', '#FFC267', '#FFD48A'] }
  });
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/ctcSplit`, {
          headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' }
        });
        setOptions(prev => ({
          ...prev,
          xaxis: { categories: data.labels || [] },
          fill: { colors: data.colors || prev.fill.colors }
        }));
        setSeries([{ name: 'Employees', data: data.series || [] }]);
      } catch (e) {
        setErr(e.message || 'Failed to load CTC split');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (err) return <div style={{color:'crimson'}}>{err}</div>;
  if (loading) return <div>Loading…</div>;

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      width="100%"
      height="300"
    />
  );
};

export default CTCBar;
